import type { SagaIterator } from 'redux-saga';
import { put, takeEvery, call } from 'redux-saga/effects';
import { INITIALIZE } from 'ext/root/root-actions';
import { getTypedContext } from 'ext/lib/saga-context';
import { resolve, reject, REFRESH_ENTITLEMENTS } from './actions';
import type { Entitlement, EntitlementsState } from './types';

export const normalize = (results: Entitlement[]): EntitlementsState => {
  return results.reduce((acc, next) => {
    acc[next.name] = next;
    return acc;
  }, {} as EntitlementsState);
};

function* fetchEntitlements(): SagaIterator {
  try {
    const api = yield* getTypedContext('api');
    const results: Entitlement[] = yield call(api.getEntitlements);
    yield put(resolve(normalize(results) as any));
  } catch (error) {
    yield put(reject(error as Error));
  }
}

export default function* saga(): SagaIterator {
  yield takeEvery(INITIALIZE, fetchEntitlements);
  yield takeEvery(REFRESH_ENTITLEMENTS, fetchEntitlements);
}
